<template>
  <div class="planRecoveryList">
    <main-right-popup-common :titleName="'回收站'" ref="mainRightPopupCommon" @loadData="loadData">
      <template v-slot:searchDiv>
        <div class="searchDiv">
          <div style="margin-top: 10px">
            <el-input style="width: 2.1rem" size="mini" v-model="keyword" placeholder="客户名称/团号/询单号/生成人"/>
            <span style="margin-left: 0.1rem;font-weight: bold;">天数&nbsp;</span>
            <el-input style="width: 0.66rem" size="mini" />
            <span style="margin-left: 0.1rem;font-weight: bold;">人数</span>
            <el-input style="width: 0.69rem" size="mini" />
            <span class="searchTravel" @click="getListData('empty')">搜索</span>
          </div>
        </div>
      </template>
      <template v-slot:dataDiv>
        <div v-for="(item,index) in informationList" :key="index">
          <plan-list-info :item="item" :planId="0" :index="index" :showCopy="false" @recoveryPlan="recoveryPlan" @delPlan="delPlan"></plan-list-info>
        </div>
      </template>
    </main-right-popup-common>
  </div>
</template>

<script>
import PlanListInfo from './child/planListInfo.vue'
import mainRightPopupCommon from '../mainRightPopupCommon.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import { getPlanInfo } from '../../js/function'
export default {
  components:{PlanListInfo,mainRightPopupCommon},
  data(){
    return{
      informationProductPage:0,
      informationList:[],
      keyword:'',
    }
  },
  methods:{
    loadData(){
      this.informationProductPage++;
      this.getListData()
    },
    getListData(type){
      this.$refs.mainRightPopupCommon.loading = true
      if(type=='empty'){
        this.informationProductPage = 1;
        this.informationList = []
      }
      new PlanApi('plan').recoveryPlanList({
        page:this.informationProductPage,
        size:10,
        q:{
          
        }
      }).then(res => {
        this.$set(this.$refs.mainRightPopupCommon,'loading',false)
        if (res.status == 200) {
          res.data.records.forEach(element => {
            this.$set(element,'showIndex',0)
            element.budgetMains.forEach(item=>{
              var str = item.planName.split(' ')
              if(str.length==1){
                this.$set(item,'planName','')
                this.$set(item,'planName1',str[0])
              }else{
                var planName=""
                str.forEach((item1,index)=>{
                  if(index!=str.length-1){
                    planName+=item1+" "
                  }
                })
                this.$set(item,'planName',planName)
                this.$set(item,'planName1',str[str.length-1])
              }
            })
          });
          this.informationList = [...this.informationList,...res.data.records]
          if(res.data.records.length<10){
            this.$refs.mainRightPopupCommon.isMore = true
          }
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    recoveryPlan(item){
      new PlanApi('plan').restorePlan({planId:item.id}).then(res => {
        if (res.status == 200) {
          this.$confirm('是否打开该恢复的方案', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setPlanId', item.id)
            getPlanInfo(item.id,null)
          }).catch((err) => {})
        }     
      })
    },
    delPlan(item){
      this.$confirm('是否确认删除该行程下的所有方案，注意：此删除之后数据无法恢复', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').removeRecoveryPlan({planId:item.id}).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"删除成功"})
            this.getListData('empty')
          }     
        })
      }).catch((err) => {})
    }
  },
  mounted(){
    this.getListData('empty')
  }
}
</script>

<style lang="scss" scoped>
.planRecoveryList /deep/ .product_body{
  top: 1.1rem !important;
}
.searchTravel {
  display: inline-block;
  height: 0.28rem;
  line-height: 0.28rem;
  margin-left: 0.2rem;
  text-shadow: 2px 2px 5px #999;
  color: #f54402;
  font-weight: bold;
  cursor: pointer;
}
</style>